<template>
  <svg class="steppoint" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13" cy="13" :r="active?12.5:7.5" :fill="red?'white':'none'" :stroke="red?'#E9041E':'none'"/>
    <circle cx="13" cy="13" :r="red?5:6" :fill="red?'#E9041E':'#AFAFAF'"/>
  </svg>

</template>

<script>
export default {
  props: {
    passed: { type: Boolean, default: false},
    active: { type: Boolean, default: false}
  },
  computed: {
    red(){
      return this.passed || this.active
    }
  }
}
</script>

<style lang="sass">
.steppoint
  display: block
  flex-shrink: 0
  *
    transition: .4s ease-out
</style>